import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const AssetsBackgroundImageFrontToolTip = (props) => (
  <div>
    Wrapper that serves as the static background of a sponsored break on desktop. Can be tiled. Will not appear on mobile or tablet. If using a background tile image, front image should be transparent .PNG file.
  </div>
);

export const AssetsBackgroundImageBackToolTip = (props) => (
  <div>
    Image will be repeated and sit behind the Background Image that serves as the background of a sponsored break on desktop. Will not appear on mobile or tablet.
  </div>
);

export const AssetsClientLogoToolTip = (props) => (
  <div>
   Image of the clients logo. Can include a retailer logo and additional images.
   <br/>
   <img src={makeToolTipUrl('break/design/11.CMS-client-logo.png')} width="100%"/>
  </div>
);

export const AssetsReportHeaderToolTip = (props) => (
  <div>
   Image of the clients logo that will appear on client reporting documents. Can not be a white logo.
  </div>
);

export const AssetsMobileClientLogoToolTip = (props) => (
  <div>
    Image of the clients logo. Can include a retailer logo and additional images. The width is fixed (306 pixels) but the height is variable.
  </div>
);

export const AssetsMobileBreakHeaderToolTip = (props) => (
  <div>
    The image that appears on mobile landing pages. When content is sponsored the image should be branded.
    <br/>
    <img src={makeToolTipUrl('break/design/12.CMS-mobile-break-header-image.png')} width="100%"/>
  </div>
);

export const AssetsHomePageTrendingToolTip = (props) => (
  <div>
    Break image that appears on a site’s homepage in the left column.
    <br/>
    <img src={makeToolTipUrl('break/design/13.CMS-Home-page-trending-image.png')} width="100%"/>
  </div>
);

export const AssetsHomePageFeaturedToolTip = (props) => (
  <div>
    Break image that appears on a site’s homepage in the middle column.
    <br/>
    <img src={makeToolTipUrl('break/design/14.CMS-home-page-featured-image.png')} width="100%"/>
  </div>
);

export const AssetsFacebookImageToolTip = (props) => (
  <div>
    Image that will appear when sharing a break on Facebook.
  </div>
);

export const AssetsPinterestImageToolTip = (props) => (
  <div>
   Image that will appear when sharing a break on Pinterest. If no image is selected, the image in “facebook image” will be pulled.
  </div>
);

export const AssetsHTMLFooterToolTip = (props) => (
  <div>
    Custom code to add for additional logos, legal lines requested by the client and whatever else your little heart desires on multi-step breaks. This will appear on every page of the break.
    <br/>
    <img src={makeToolTipUrl('break/design/15.CMS-HTML-footer-all-pages.png')} width="100%"/>
  </div>
);

export const AssetsMobileHTMLFooterToolTip = (props) => (
  <div>
    Custom code to add for additional logos, legal lines requested by the client and whatever else your little heart desires on multi-step breaks being viewed on mobile. If no code is entered, the code from the “HTML footer on all break pages” field will be used. This will appear on every page of the break. Recommended when several additional logos are necessary.
    <br/>
    <img src={makeToolTipUrl('break/design/16.CMS-mobile-HTML-footer-all-pages.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-design-section-tool-tips.jsx